<script src="../../../directives/registerDirective.js"></script>
<template>
  <div class="load-hide">
    <div class="load-hide" style="height:100%;">
      <div class="context cq_context">
        <!--<div class="the_number">-->
          <!--<div class="relieve"><input type="button" value="解绑" @click="unBind"></div>-->
        <!--</div>-->
        <!--<div class="out-all" style="display:none;">-->
          <!--<div class="include-black"></div>-->
          <!--<div class="include-text">-->
            <!--<p>提示</p>-->
            <!--<p>您确认要解绑门店卡吗？</p>-->
            <!--<div>-->
              <!--<input type="button" value="取消" class="choose-no" @click="closeQ">-->
              <!--<input type="button"  value="确认" class="choose-yes" @click="unBindOk">-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <div class="title two-picture">
          <div class="setup_icon"><span @click="goSetup"></span></div>
          <div class="title_img"><hr> <img src="../../../assets/img/freshone.png"> <hr></div>
          <div class="erweima-img" id="qrCodeImg" style="display:inline-block;"></div>
          <div class="two_bottom">
            <p class="the_number_card">No.{{card_num}}</p>
            <p style="color: #cb0000;margin: 0"><span @click="reloads" class="card_making_icon"></span>¥ {{ava_balance}}</p>
            <!--<div class="recharge-recode"><input style="padding:0" type="button" value="充值记录"></div>-->
          </div>
        </div>
        <div class="get_now"><input type="button" value="充值" @click="goRecharge"></div>
        <div class="get_now"><input type="button" value="账单" @click="goBill"></div>
        <!--<div class="get_now"><input type="button" value="设置" @click="goSetup"></div>-->
      </div>
    </div>
  </div>
</template>

<script>

import auth from '../../../lib/auth';
import constants from '../../../lib/constants';
export default {
  data(){
      return{
        ava_balance:"",
        card_num:"",
      }
  },
  mounted(){
    this.getVip()
//    this.reload()
  },
  methods: {
      reloads(){
          window.location.reload();
      },
      reload(){
          console.log(1)
          setInterval(function(){
            window.location.reload();
          },150000)
      },
      //充值
    goRecharge(){
        router.push("recharge");
    },
    goBill(){
      router.push("bill");
    },
    goSetup(){
      router.push("setup");
    },
    //会员卡信息 支付码
    getVip(){
          this.$http.post(constants.API_HOST + constants.API_VIEW_CARD, {
          }).then((result) => {
            let data = result.data;
            if (data.code === "200") {
              console.log(data.data);
              this.ava_balance = data.data.card.ava_balance;
              if(this.ava_balance == 0){
                this.ava_balance = "0.00"
              }
              this.card_num = data.data.card.card_num;
              var qrcode  = data.data.payQrcode;
              $("#qrCodeImg").qrcode({
//                render: "table", //table方式
                text:qrcode,
                width:210,
                height:210
              })
            }else {
              this.$alert(data.data);
            }
          }, (error) => {
            error.data && this.$alert(error.data);
          });
    },
    //解绑会员卡
    unBind(){
      $(".out-all").show();
    },
    closeQ(){
      $(".out-all").hide();
    },
    unBindOk(){
      this.$http.post(constants.API_HOST + constants.API_UNBIND_CARD, {
      }).then((result) => {
        let data = result.data;
        if (data.code === "200") {
          location.href="main.html#/main";
          console.log(123);
        } else {
          this.$alert(data.data);
        }
      }, (error) => {
        error.data && this.$alert(error.data);
      });
    }
  }

}

</script>

<style>
  .card_making_icon{
    background-image: url(../../../assets/img/main/card_making_icon.png);
    width: 0.14rem;
    height: 0.14rem;
    background-size: 0.14rem 0.14rem;
    background-repeat: no-repeat;
    display: inline-block;
    vertical-align: middle;
    margin-top: -0.03rem;
    margin-right: 0.08rem;
  }
  .hdiv{
    display:none;
  }
  body,html{
    height:100%;
  }
  html {
    font-size:90px!important
  }
  @media only screen and (min-width:319px) {
    html {
      font-size:100px!important
    }
  }@media only screen and (min-width:370px) {
    html {
      font-size:117px!important
    }
  }@media only screen and (min-width:414px) {
    html {
      font-size:129px!important
    }
  }
  @media only screen and (min-width:639px) {
    html {
      font-size:200px!important
    }
  }
  .out-all{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1;
    font-size:0.15rem;
  }
  .include-black{
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.8;
    width: 100%;
    height: 100%;
  }
  .include-text{
    background: #fff;
    width: 80%;
    /*height: 1.2rem;*/
    z-index: 3;
    position: absolute;
    text-align: center;
    top: 2.2rem;
    border-radius: 0.05rem;
    margin: 0 10%;
  }

  .include-text p{
    margin: 0.1rem 0;
    font-size: 0.13rem;
  }
  .include-text div{
    margin-top: 0.2rem;
  }
  .include-text img{
    width: 200px;
  }

  .include-text input{
    border: 0px;
    background: #3d9946;
    color: #FFF;
    width: 0.875rem;
    height: 0.235rem;
    border-radius: 0.01rem;
  }
  .choose-no{
    background: #F0F3F6 !important;
    color:#000 !important;
  }
  .cq_context{
    background: #3d9946;
    padding: 0.15rem 0.19rem 0.1rem;
    min-height:100%;
  }
  .the_number{
    width: 100%;
    font-size: 0.13rem;
    padding: 0.195rem 0.19rem 0;
    margin: 0 0 0.195rem;
    position: relative;
  }
  .relieve{
    position: absolute;
    top:0.18rem;
    right: 0.2rem;
    font-size:0.12rem;
  }
  .title{
    width: 100%;
    text-align: center;
  }
  .relieve input{
    width: 0.495rem;
    height: 0.21rem;
    line-height: 0.1rem;
    border: 0px;
    background: #50a200;
    color: #fff;
    border-radius: 0.1rem;
  }
  .two-picture{
    background: #fff;
    text-align: center;
    padding-top: 0.09rem;
    border-radius: 8px;
  }
  .title_img{
    display: flex;
    justify-content: center;
  }
  .title_img hr{
    border-top:1px solid #949494;
    width: 0.3rem;
    margin: 0.25rem 0;
  }
  .title_img img{
    width:1.16rem;
    height:0.515rem;
    margin: 0 0.15rem;
  }
  .two_bottom{
    width: 100%;
    padding: 0.15rem 0.19rem 0.1rem;
    background: #fafafa;
    border-radius: 8px;
  }
  .two_bottom p{
    display: block;
    width: 100%;
    font-size: 0.15rem;
    text-align: center;
    letter-spacing: 1px;
    color:#252525;
  }
  .recharge-recode input{
    width: 0.63rem;
    height: 0.2rem;
    line-height: 0.1rem;
    border: 0px;
    background: #fff;
    color: #727272;
    border-radius: 0.1rem;
    text-align: center;
  }
  .get_now{
    margin-top: 0.1rem;
    width: 100%;
    font-size: 0.15rem;
  }
  @media (max-width: 320px) {
    .get_now{
      margin-top: 0.08rem;
    }
  }
  .get_now input{
    width: 100%;
    height: 0.44rem;
    border: 0;
    background: #5aa862;
    border-radius: 0.05rem;
    color: #fff;
  }
  .erweima-img{
    margin: 0.225rem 0;
    width: 210px;
    height: 210px;
  }
  .erweima-img canvas{
    width: 100%!important;
  }
  .erweima-img-ele canvas{
    position: absolute;
    width: 2rem;
    height: 2rem;
    left: 18%;
  }
  .erweima-img-ele{
    width: 2rem;
    height: 2rem;
    margin:0.4rem 0;
  }
  .setup_icon{
    width: 100%;
    text-align: right;
    padding: 0 9px;
  }
  .setup_icon span{
    background-image: url(../../../assets/img/setup.png);
    background-repeat: no-repeat;
    width: 0.24rem;
    height: 0.24rem;
    background-size: cover;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// card_qrcode.vue?5c30185e